import styled from 'styled-components'

export const Container = styled.div<{ color: string }>`
  background: var(${({ color }) => color});
  border-radius: 4px;
  padding: 8px 4px;
  width: 100%;
`
